var _excluded = ["content", "children", "backgroundColor", "backgroundImage", "mobileImage", "customColor", "backgroundLink", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import ConditionalWrapper from "../../../helpers/ConditionalWrapper";
import { getBackgroundByTextColor } from "../../../utils/getCustomColor";
import { Content, StyledContainerOrg, StyledImage, BackgroundWrapper, ItemsWrapper, StyledLink, BanerWrapper } from "./ContentWithItemsOrg.styled";
function ContentWithItemsOrg(_ref) {
  var content = _ref.content,
    children = _ref.children,
    backgroundColor = _ref.backgroundColor,
    backgroundImage = _ref.backgroundImage,
    mobileImage = _ref.mobileImage,
    customColor = _ref.customColor,
    backgroundLink = _ref.backgroundLink,
    onClick = _ref.onClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var handleClick = function handleClick() {
    if (onClick) {
      onClick();
    }
  };
  var $backgroundByTextColor = getBackgroundByTextColor(customColor === null || customColor === void 0 ? void 0 : customColor.text);
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: $backgroundByTextColor || backgroundColor
  }, /*#__PURE__*/React.createElement(BanerWrapper, null, /*#__PURE__*/React.createElement(BackgroundWrapper, _extends({
    $backgroundColor: backgroundColor,
    $backgroundImage: backgroundImage,
    $customColor: customColor
  }, restProps), /*#__PURE__*/React.createElement(StyledContainerOrg, {
    width: "default"
  }, /*#__PURE__*/React.createElement(Content, {
    onClick: handleClick
  }, content), /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: !!backgroundLink,
    wrapper: function wrapper(image) {
      return /*#__PURE__*/React.createElement(StyledLink, {
        openInNewTab: backgroundLink === null || backgroundLink === void 0 ? void 0 : backgroundLink.openInNewTab,
        title: (backgroundLink === null || backgroundLink === void 0 ? void 0 : backgroundLink.title) || "",
        href: backgroundLink === null || backgroundLink === void 0 ? void 0 : backgroundLink.href,
        to: backgroundLink === null || backgroundLink === void 0 ? void 0 : backgroundLink.to,
        onClick: backgroundLink === null || backgroundLink === void 0 ? void 0 : backgroundLink.onClick
      }, image);
    }
  }, /*#__PURE__*/React.createElement(StyledImage, {
    srcData: mobileImage,
    alt: mobileImage.alt
  })))), /*#__PURE__*/React.createElement(ItemsWrapper, null, /*#__PURE__*/React.createElement(StyledContainerOrg, {
    width: "default"
  }, children))));
}
export default ContentWithItemsOrg;